//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LensesDisclaimer',

  data: function () {
    return {
      isOpenDisclaimer: false,
      disclaimerAdvantages: [
        {
          value: `<span><strong>Стандартные линзы:</strong> Подходят для большинства потребителей со стандартными параметрами зрения и посадки оправы на лице, обеспечивая базовый уровень коррекции зрения.</span>`
        },
        {
          value: `<span><strong>Индивидуальные линзы:</strong> Учитывают дополнительные параметры, такие как форма оправы и индивидуальные особенности зрения, для улучшения зрительного комфорта. Создаются с использованием технологии DRP - Digital Ray Path. Позволяют минимизировать искажения на периферии, которые ощущают пользователи с нестандартными параметрами зрения и посадки оправы.</span>`
        },
        {
          value: `<span><strong>Премиальные индивидуальные линзы:</strong> Создаются с использованием передовых технологий, таких как  DRP2, учитыывают закон Листинга. Обеспечивают максимальное качество зрения по всей поверхности линзы. </span>`
        }
      ]
    }
  },
  methods: {
    toggleDisclaimer: function () {
      this.isOpenDisclaimer = !this.isOpenDisclaimer
    }
  }
}
